import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { CSSProperties, FC } from 'react';
import { Icon } from '@/components/ui/icon/icon';

type FeatureItem = {
  icon: string;
  title: string;
  description: string;
};

type Props = {
  features: FeatureItem[];
  featureCircleBackground: string | null;
  iconSize?: SizeProp;
  titleColor?: string;
  descriptionColor?: string;
  paddingStyle?: CSSProperties;
};

const IconsWithDescription: FC<Props> = ({
  features,
  featureCircleBackground,
  iconSize = 'xl',
  titleColor,
  descriptionColor,
  paddingStyle,
}) => {
  return (
    <div
      className="container mx-auto flex w-full flex-col items-center gap-12 @md:gap-24"
      style={paddingStyle}
    >
      <div className="mx-4 mb-4 flex w-full flex-wrap justify-center gap-12">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex w-full max-w-[260px] flex-col items-center gap-1 self-start px-2"
          >
            <div
              className={`flex size-10 items-center justify-center rounded-full p-2 text-white ${featureCircleBackground ? '' : 'bg-primary'}`}
              style={{
                background: featureCircleBackground ? featureCircleBackground : undefined,
              }}
            >
              <Icon icon={feature.icon} size={iconSize} />
            </div>
            <span
              className="text-md text-center font-medium @md:text-lg"
              style={titleColor ? { color: titleColor } : undefined}
            >
              {feature.title}
            </span>
            <span
              className="text-center text-sm text-zinc-600"
              style={descriptionColor ? { color: descriptionColor } : undefined}
            >
              {feature.description}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IconsWithDescription;
